module.exports = __webpack_public_path__ + "img/ckc.2436c9ff.jpg";